<template>
  <div class="notifications-page-header" data-testid="email-notifications__header">
    <h3 class="notifications-page-header__title">{{ title }}</h3>
    <p class="notifications-page-header__desc">{{ description }}</p>
  </div>
</template>

<script>
export default {
  name: 'NotificationsPageHeader',
  props: {
    title: { type: String, default: 'Automations' },
    description: {
      type: String,
      default: 'Reminders, alerts and escalations that run across your close cycles.',
    },
  },
};
</script>

<style lang="scss" scoped>
.notifications-page-header {
  margin-bottom: 16px;
  &__title { margin: 0; }
  &__desc { margin: 4px 0 0; color: var(--color-text-sub, #616c70); }
}
</style>
